import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box, Button, ButtonProps, Collapse, styled, Typography } from '@mui/material'

import { FC, useCallback } from 'react'

import { formatAnswer } from './faqUtils'

const FAQButton = styled(Button)<ButtonProps>(({ theme }) => ({
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  color: theme.palette.text.primary,
  fontSize: 16,
  fontWeight: 600,
  justifyContent: 'start',
  letterSpacing: 0,
  paddingBottom: theme.spacing(1.5),
  paddingLeft: theme.spacing(0.5),
  paddingTop: theme.spacing(1.5),
  textAlign: 'left',
  textTransform: 'none',
  width: '100%',
}))

const AnswerContent = styled(Box)(({ theme }) => ({
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  '& a:hover': {
    color: theme.palette.primary.light,
  },
  '& b, & strong': {
    fontWeight: 700,
  },
  color: theme.palette.text.secondary,
  fontSize: 14,
  letterSpacing: 0,
  lineHeight: 1.6,
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(1),
}))

type FAQItemProps = {
  answer: string
  isExpanded: boolean
  onToggle: () => void
  question: string
}

export const FAQItem: FC<FAQItemProps> = (props) => {
  const handleClick = useCallback(() => {
    props.onToggle()
  }, [props])

  return (
    <Box>
      <FAQButton
        aria-expanded={props.isExpanded}
        onClick={handleClick}
        startIcon={props.isExpanded ? <RemoveIcon /> : <AddIcon />}
        variant="text"
      >
        {props.question}
      </FAQButton>
      <Collapse in={props.isExpanded}>
        <AnswerContent>
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: formatAnswer(props.answer) }}
            variant="body2"
          />
        </AnswerContent>
      </Collapse>
    </Box>
  )
}
FAQItem.displayName = 'FAQItem'
